import { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router'
import chevLeft from '../../../assets/New-images/chevron-left-blk.svg'
import { getQuizByQuizId } from '../../../store/dashboard/actions'
import { getQuizFeatures } from '../../../store/quizzes/actions'
import QuizSubmissionList from '../QuizSubmissionList/QuizSubmissionList'

function QuizzesAllSubmissionsById() {
  const params: any = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const [enableLearning, setEnableLearning] = useState(false)
  const [quizDetail, setQuizDetail] = useState(null)
  const [decimalPlaces, setDecimalPlaces] = useState('2')

  useEffect(() => {
    if (!params.quizId) {
      history.goBack()
      return
    }

    getQuiz(params.quizId)
    getLearningFeature()
  }, [])

  const getLearningFeature = async () => {
    try {
      const response: any = await dispatch(getQuizFeatures())
      if (response.features && response.features.length !== 0) {
        for (let i = 0; i < response.features.length; i++) {
          if (response.features[i].name === 'learning') {
            setEnableLearning(true)
            break
          }
        }
      } else {
        setEnableLearning(false)
      }
    } catch (error) {
      setEnableLearning(false)
    }
  }

  const getQuiz = async (quizId: string) => {
    try {
      const { quizDetail }: any = await dispatch(getQuizByQuizId(quizId))
      setQuizDetail(quizDetail)

      if (
        'score_decimal_number' in quizDetail &&
        quizDetail.score_decimal_number !== null
      ) {
        setDecimalPlaces(quizDetail.score_decimal_number.toString())
      } else {
        setDecimalPlaces('2')
      }
    } catch (error) {}
  }

  return (
    <section className="page-mid-wraper h-without-foter">
      <div>
        <div className="d-flex flex-md-nowrap flex-wrap align-items-center p-0 mb-4">
          <button
            className="btn py-0 pl-0"
            onClick={() => {
              history.goBack()
            }}
          >
            <img src={chevLeft} alt="" />
          </button>
          <h5 className="font-weight-bold mb-0 p-0 ml-2">{quizDetail?.name}</h5>
        </div>

        <Row>
          <Col md={12}>
            <div className="">
              {quizDetail && (
                <QuizSubmissionList
                  enableLearning={enableLearning}
                  quizId={params.quizId}
                  decimalPlaces={decimalPlaces}
                  quizName={quizDetail?.name}
                />
              )}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  )
}

export default QuizzesAllSubmissionsById
